


































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import urlParser from 'js-video-url-parser/lib/base';
import 'js-video-url-parser/lib/provider/vimeo';
import 'js-video-url-parser/lib/provider/youtube';

import { urlMediaType } from '@/utils/text';
import { toSeconds, toDateTime } from '@/utils/timeFormat';

@Component
export default class VideoModal extends Vue {
  @Prop() readonly linked_id!: string | null;
  @Prop() readonly mode!: string;
  @Prop() readonly video!: any;
  @Prop() readonly video_name!: string;

  video_instance: any = {
    ...this.video,
    settings: {
      ...this.video.settings,
    },
  };

  mounted() {
    if (['youtube', 'vimeo'].indexOf(this.video_instance.type) > -1) {
      this.video_instance.id = urlParser.create({
        videoInfo: {
          provider: this.video_instance.type,
          id: this.video_instance.id,
          mediaType: 'video',
        },
        format: 'long',
      });
    }
  }

  validate() {
    if (
      !this.video_instance.id ||
      !/^https?:\/\//.test(this.video_instance.id)
    ) {
      this.$buefy.toast.open({
        message: 'A valid source URL is required.',
        type: 'is-warning',
      });
      return;
    }

    return true;
  }
  save() {
    if (!this.validate()) {
      return;
    }

    if (['youtube', 'vimeo'].indexOf(this.video_instance.type) > -1) {
      const provider_parse = urlParser.parse(this.video_instance.id);
      if (
        !provider_parse ||
        provider_parse.provider !== this.video_instance.type
      ) {
        this.$buefy.toast.open({
          message: 'A valid source URL is required.',
          type: 'is-warning',
        });
        return;
      } else {
        this.video_instance.id = provider_parse.id;
      }
    } else {
      let url_media = urlMediaType(this.video_instance.id);
      if (!url_media) {
        this.$buefy.toast.open({
          message: 'A valid source URL is required.',
          type: 'is-warning',
        });
        return;
      }
    }

    this.$emit('save', this.video_instance);
    this.$emit('close');
  }
}
